<template>
    <!-- ACTION BAR -->
    <div class="container-action-bar">
        <CompassTooltip v-if="canUpdateRelated" :arrow="false" :content="labels.addRelatedObject">
            <CompassIconButton
                icon="objects-linked"
                size="small"
                @click="showLinkObjectDialog = true"
            />
        </CompassTooltip>
        <CompassTooltip :arrow="false" :content="labels.showHistoryTooltip">
            <CompassIconButton
                icon="history"
                size="small"
                :active="displayHistory"
                @click="$emit('toggleHistory')"
            />
        </CompassTooltip>
        <CompassTooltip v-if="showPinIcon" :arrow="false" :content="pinStatusLabel">
            <CompassIconButton
                icon="pin"
                size="small"
                :active="isPinned"
                @click.stop="onClickPin"
            />
        </CompassTooltip>
        <CompassTooltip v-if="!isFailedToSend" :arrow="false" :content="labels.showEmailTooltip">
            <CompassIconButton
                icon="panel-right-expand"
                size="small"
                @click="previewElement(oneLog)"
            />
        </CompassTooltip>
        <!-- Custom tooltip for 'more actions' -->
        <div v-if="shouldDisplayMenuMoreActions">
            <div ref="customTooltip" :class="customTooltipClasses">
                {{ labels.moreActionsTooltip }}
            </div>
            <CompassMenu
                ref="actionBarMenu"
                size="small"
                placement="top-end"
                :disabled="!isActionBarVisible"
            >
                <CompassIconButton
                    icon="action"
                    size="small"
                    @click="handleCustomTooltipVisibility"
                    @mouseenter="handleCustomTooltipVisibility"
                    @mouseleave="handleCustomTooltipVisibility"
                />
                <template #dropdown>
                    <CompassMenuItem
                        v-if="canLinkEmail"
                        :label="labels.menuLinkEmail"
                        @click="linkElement(oneLog)"
                    />
                    <CompassMenuItem
                        v-if="oneLog.email.scheduled"
                        :label="labels.menuCancelSendEmail"
                        @click="cancelSendElement(oneLog)"
                    />
                </template>
            </CompassMenu>
        </div>

        <LinkObjectDialog
            v-if="canUpdateRelated"
            :isVisible="showLinkObjectDialog"
            :related="linkedsFormated"
            :isLoading="linkObjectDialogLoading"
            :hasError="hasRelatedUpdateError"
            :emptyStateData="emptyStateData"
            @close="showLinkObjectDialog = false"
            @update:related="updateRelatedObjects"
        />
    </div>
</template>
<script>
import LinkObjectDialog from 'vcomponents/common/object/LinkObjectDialog.vue';
import { updateProviderThreadMessagesRelatedBatch } from 'api/emailEngine/emailEngineService';
import TimelineActionBar from 'vcomponents/timeline/timelineActionBar/TimelineActionBar.vue';
import Feature from 'Services/Feature';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    name: 'TimelineActionBarEmail',
    components: {
        LinkObjectDialog,
    },
    extends: TimelineActionBar,
    props: {
        isDocument: {
            type: Boolean,
            required: true,
        },
        overviewType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            labels: {
                showEmailTooltip: this.$l10n.__("Afficher l'email"),
                menuLinkEmail: this.$l10n.__("Lier l'email"),
                menuCancelSendEmail: Feature.isEnabled('email-engine')
                    ? this.$t.__('common.actions.delete')
                    : this.$t.__('timeline.EmailCardV2.cancel_send'),
                addRelatedObject: this.$t.__('common.actions.manage_related'),
            },
            showLinkObjectDialog: false,
            linkObjectDialogLoading: false,
            hasRelatedUpdateError: false,
            emptyStateData: {
                title: this.$t.__('email.listings.linkObjectDialog.empty_state_title'),
                caption: this.$t.__('email.listings.linkObjectDialog.empty_state_caption'),
                illustrationPath: '/ressources/logged/img/illustrations/empty-activities.svg',
            },
        };
    },
    computed: {
        isEmailEngine() {
            return Feature.isEnabled('email-engine');
        },
        showPinIcon() {
            return !this.isDocument && this.overviewType !== 'staff';
        },
        canLinkEmail() {
            return (
                this.oneLog.email.provider === 'nylas' &&
                this.oneLog.email.threadId &&
                !this.isEmailEngine &&
                this.oneLog.isMine
            );
        },
        isFailedToSend() {
            return this.oneLog.email.email_status === 'FAILED_TO_SEND';
        },
        shouldDisplayMenuMoreActions() {
            return this.oneLog.email.scheduled || this.canLinkEmail;
        },
        canUpdateRelated() {
            return this.isEmailEngine && !!this.decodedEmailThreadId && !!this.currentLinked;
        },
        decodedEmailThreadId() {
            return !!this.oneLog.email.threadId ? atob(this.oneLog.email.threadId) : null;
        },
        linkedsFormated() {
            const linkedsFormated = this.oneLog.linkeds.map((linked) => ({
                data: linked,
                blockType: linked.type,
            }));

            if (this.currentLinked) {
                linkedsFormated.unshift(this.currentLinked);
            }

            return linkedsFormated;
        },
        currentLinked() {
            const linkedType = this.subtype ?? this.linkedtype;
            switch (linkedType) {
                case 'company':
                case 'prospect':
                case 'supplier':
                case 'third':
                case 'client':
                case 'individual':
                    if (this.$store.state.third) {
                        return {
                            data: {
                                id: this.linkedid,
                                type: linkedType,
                                name: this.$store.state.third.identity.name,
                                email: this.$store.state.third.identity.email,
                                mobile: this.$store.state.third.identity.mobile,
                            },
                            blockType: linkedType,
                        };
                    }
                    return null;
                case 'contact':
                case 'people':
                    if (this.$store.state.people) {
                        return {
                            data: {
                                id: this.linkedid,
                                type: linkedType,
                                name: this.$store.state.people.identity.name,
                                email: this.$store.state.people.identity.email,
                                mobile: this.$store.state.people.identity.mobile,
                            },
                            blockType: linkedType,
                        };
                    }
                    return null;
                case 'opportunity':
                    if (this.$store.state.opportunity) {
                        return {
                            data: {
                                id: this.linkedid,
                                type: linkedType,
                                name: this.$store.state.opportunity.identity.name,
                            },
                            blockType: linkedType,
                        };
                    }
                    return null;
                case 'order':
                case 'model':
                case 'invoice':
                case 'estimate':
                case 'delivery':
                case 'proforma':
                case 'creditnote':
                    if (this.$store.state.documentOverview) {
                        return {
                            data: {
                                id: this.linkedid,
                                type: linkedType,
                                name: this.$store.state.documentOverview.docnumber,
                            },
                            blockType: linkedType,
                        };
                    }
                    return null;
                default:
                    return null;
            }
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        previewElement(onelog) {
            if (this.isEmailEngine && onelog.email.provider === 'nylas') {
                if (this.oneLog.email.email_status === 'SCHEDULED_TO_BE_SENT') {
                    EventBus.emit('emailPreviewPanel:new', { params: [{ email: onelog.email }] });
                } else {
                    EventBus.emit('emailConsultPanel:new', { params: [{ oneLog: onelog }] });
                }
            } else {
                if (onelog.email.provider === 'nylas') {
                    if (!onelog.email.threadId) {
                        EmailBox.preview(onelog.objectid);
                    } else if (onelog.isMine) {
                        EmailBox.view(
                            onelog.email.threadId,
                            undefined,
                            onelog.eventDetails.message_id,
                        );
                    } else {
                        EmailBox.preview(
                            onelog.email.threadId,
                            undefined,
                            onelog.owner ? onelog.owner.id : undefined,
                            onelog.eventDetails.message_id,
                        );
                    }
                } else if (onelog.email.provider === 'sendgrid') Email.view(onelog.objectid);
            }
        },
        linkElement(mail) {
            if (!this.isEmailEngine) {
                EventBus.emit('timeline:linkEmail', mail);
            }
        },
        cancelSendElement(mail) {
            if (!this.isEmailEngine) {
                EventBus.emit('timeline:cancelSendEmail', mail);
            } else {
                this.open({
                    key: 'emailDeleteConfirmDialog',
                    props: {
                        email: {
                            ...this.oneLog.email,
                            id: mail.objectid,
                        },
                    },
                });
            }
        },
        updateRelatedObjects(newRelatedObjects) {
            this.linkObjectDialogLoading = true;
            this.hasRelatedUpdateError = false;

            const formatedData = [
                {
                    type: 'thread',
                    id: this.decodedEmailThreadId,
                    related: this.formatRelatedObjects(newRelatedObjects),
                },
            ];
            updateProviderThreadMessagesRelatedBatch('/emails/related/batch', formatedData)
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        close: true,
                        text: this.$t.__(
                            'email.listings.ReceivedEmailListing.success_updating_related_objects',
                        ),
                    });
                    this.hasRelatedUpdateError = false;
                    this.showLinkObjectDialog = false;

                    this.$nextTick(() => {
                        EventBus.emit('timeline:refresh');
                    });
                })
                .catch(() => {
                    this.hasRelatedUpdateError = true;
                })
                .finally(() => {
                    this.linkObjectDialogLoading = false;
                });
        },
        formatRelatedObjects(related) {
            return related.map((relatedItem) => this.simplifyRelatedObject(relatedItem));
        },
        simplifyRelatedObject(relatedItem) {
            if (relatedItem.data.object) {
                return {
                    id: relatedItem.data.object.id,
                    type: relatedItem.data.object.sub_type,
                };
            }

            return {
                id: relatedItem.data.id,
                type: relatedItem.data.type,
            };
        },
    },
};
</script>
